export const LeadRatingEnum = {
  lookupTypeId: 32,
};
